import React from 'react';
import Link from 'next/link';
import { string } from 'prop-types';
import styled from 'styled-components';
import { Title } from '@seaweb/coral/components/Typography';

const StyledArticleBox = styled.a`
  height: 135px;
  width: 100%;
  margin: 20px 12px;
  padding: 22px 24px;
  border-radius: 4px;
  color: #202325;
  box-sizing: border-box;
  overflow: hidden;
  background: white;
  cursor: pointer;

  &:hover {
    box-shadow: 0 16px 30px 0 rgba(102, 138, 184, 0.1);
  }

  @media screen and (max-width: 600px) {
    margin: 10px 0;
    height: auto;
  }

  @media screen and (min-width: 1200px) {
    max-width: 552px;
  }
`;

const Description = styled.div`
  margin-bottom: 24px;
  opacity: 0.6;
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  line-height: 28px;
  color: #202325;

  @media screen and (max-width: 600px) {
    margin-bottom: 0;
  }
`;

const ArticleTitle = styled(Title)`
  font-size: 18px;
  font-weight: bold;
  color: #202325;
  margin-bottom: 12px;
  max-height: 50px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

function ArticleBox({ title, preview, href }) {
  return (
    <Link href={href}>
      <StyledArticleBox>
        <ArticleTitle>{title}</ArticleTitle>
        <Description>{preview}</Description>
      </StyledArticleBox>
    </Link>
  );
}

ArticleBox.propTypes = {
  title: string.isRequired,
  preview: string.isRequired,
  href: string.isRequired,
};

export default ArticleBox;
